import * as _ from 'lodash';

import { Group, TreeType } from '../../models';

const separator = '/';

export interface DropDownItem {
    guid: string;
    name: string;
    url: string;
    urlParams: { groupGuid: string };
}

export interface Level extends DropDownItem {
    siblings?: DropDownItem[];
    children?: DropDownItem[];
}

export function getModel(group: Group, tree: TreeType[], byLevel: { key: string, values: TreeType[] }[], stateName: string): Level[] {
    const maxLevels = 5;
    let retval = [];
    if (group && tree && byLevel) {
        const treeItem = _.find(tree, t => t.guid === group.guid);
        if (treeItem) {
            retval = getList(treeItem, byLevel, stateName, tree, maxLevels);
        }
    }
    return retval;
}

function getList(item: TreeType, byLevel: { key: string, values: TreeType[] }[], stateName: string, tree: TreeType[], maxLevels: number) {
    let retval = [];
    const nameParts = item.absoluteName.split(separator);
    for (let index = item.depth; index > 0; index--) {
        const level = _.find(byLevel, l => l.key === index.toString());
        if (level) {
            const myObj = {
                name: item.name,
                url: stateName,
                urlParams: { groupGuid: item.guid },
                siblings: getSiblings(level.values, item, tree, nameParts, index, stateName),
                guid: item.guid
            };
            retval.push(myObj);
            if (retval.length === maxLevels) {
                break;
            }
        }
        item = item.parent as TreeType;
    }
    retval = retval.reverse();
    return retval;
}

export function getChildren(group: Group, tree: TreeType[], byLevel: { key: string, values: TreeType[] }[], stateName: string): DropDownItem[] {
    if (group && tree) {
        const treeItem = _.find(tree, t => t.guid === group.guid);
        return treeItem?.children
            ? treeItem.children.map(c => {
                return {
                    name: c.name,
                    url: stateName,
                    urlParams: { groupGuid: c.guid },
                    guid: c.guid
                };
            })
            : [];
    }
    return [];
}

function getSiblings(values: TreeType[], item: TreeType, tree: TreeType[], nameParts: string[], index: number, stateName: string): DropDownItem[] {
    return values
        .filter(v => v.parentGUID === item.parent.guid && v.guid !== item.guid)
        .map(v => {
            let guid = v.guid;
            const updatedName = nameParts.map((n, i) => {
                return i === index ? v.name : n;
            })
                .join(separator);
            const matching = _.find(tree, t => t.absoluteName === updatedName);
            if (matching) {
                guid = matching.guid;
            }
            return {
                name: v.name,
                url: stateName,
                urlParams: { groupGuid: guid },
                guid
            };
        });
}